'use client';

import { PaperPlaneIcon } from '@radix-ui/react-icons';
import { useRouter } from 'next/navigation';
import { useState } from 'react';

import GainAdvantageIcon from '@/components/icons/GainAdvantageIcon';
import AppButton from '@/components/ui/Button';
import { ChatStore } from '@/features/stores/ChatStore';
import { PublicMessageToChatStore } from '@/features/stores/PublicMessageToChatStore';

function IntroSearch() {
  const [inputText, setInputText] = useState<string>('');
  const router = useRouter();

  const goToNewChat = () => {
    ChatStore.setState((s) => ({ ...s, chatId: '', chatName: null }));
    PublicMessageToChatStore.setState((s) => ({ message: inputText }));
    router.push('/chat');
  };

  return (
    <div className="mx-auto w-full max-w-256 px-2 pt-10 md:px-5 lg:pt-15">
      <div className="shadow-primary-shadow border-border-stroke flex w-full rounded-lg border-[1px] border-solid p-1">
        <input
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          className="text-input-mobile md:text-input w-full px-3 py-2 outline-0 md:px-5 md:py-3"
          placeholder="How We Can Help You?"
        />
        <AppButton
          disabled={inputText.length < 2}
          onClick={goToNewChat}
          className="disabled:!bg-primary disabled:!opacity-100"
        >
          <GainAdvantageIcon className="mr-2 hidden md:inline" />
          <PaperPlaneIcon className="inline h-6 w-5 md:hidden" />
          <span className="text-label-md hidden whitespace-nowrap md:inline">Start Chat</span>
        </AppButton>
      </div>
    </div>
  );
}

export default IntroSearch;
